import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Protege el shell autenticado. Es CanMatch (no CanActivate) para que el chunk
 * lazy NO se descargue sin sesión. En fallo devuelve UrlTree a /ingreso/ingresar
 * preservando el deep-link en ?redirect= (round-trip post-login).
 */
export const authGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  const attemptedUrl = router.currentNavigation()?.initialUrl.toString();
  const redirect =
    safeRedirectUrl(attemptedUrl) ?? '/' + segments.map((segment) => segment.path).join('/');
  return router.createUrlTree(['/ingreso/ingresar'], {
    queryParams: { redirect },
  });
};

function safeRedirectUrl(value: string | null | undefined): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return null;
  if (value.startsWith('/ingreso')) return null;
  return value;
}
